var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferCold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Product_Can_Solid-Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.368,
    height: 29.408,
    viewBox: "0 0 17.368 29.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Product_Can_Solid",
    d: "M27.882,9.194l-.408-.431h-13.5l-.408.408a1.456,1.456,0,0,0-.426,1.025V29.565a.755.755,0,0,0,.779.773H27.553a.749.749,0,0,0,.755-.755V10.219a1.456,1.456,0,0,0-.426-1.025ZM16.969,24.836a.521.521,0,1,1-1.037,0V12.85a.521.521,0,1,1,1.037,0ZM18.216,6.755H14.572a.527.527,0,0,0,0,1.049h12.4a.527.527,0,0,0,0-1.049H19.432V6.7L15.9,1.176A.527.527,0,0,0,15.453.93H11.461a.521.521,0,1,0,0,1.043h3.71Z",
    transform: "translate(-10.94 -0.93)",
    fill: "#ed8b00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferCold);
export default __webpack_public_path__ + "static/media/offer_cold.7b4416b33386551c6810b0f856d6d935.svg";
export { ForwardRef as ReactComponent };